import { Injectable } from '@angular/core';

@Injectable()
export class StorageFactory {
    constructor() {}

    getItem(key : string) {
        return localStorage.getItem(key);
    }

    setItem(key : string, val : string) {
        try {
            localStorage.setItem(key, val);
        } catch (e) {
            console.error(e);
            return false;
        }
        return true;
    }

    removeItem(key : string) {
        try {
            localStorage.removeItem(key)
        } catch (e) {
            return false;
        }
        return true;
    }
};



// WEBPACK FOOTER //
// D:/dclean-web-latest/cot-web/src/app/core/storage/storage.factory.ts